import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const types = [
  {
    title: "Passenger Elevators",
    description: "Designed for residential towers, offices, and public buildings, passenger elevators provide smooth and efficient movement with a strong focus on comfort and safety.",
    icon: "Users"
  },
  {
    title: "Freight Elevators",
    description: "Freight elevators are engineered to handle heavy loads and support commercial and industrial operations that require durable lifting solutions.",
    icon: "Package"
  },
  {
    title: "Panoramic Elevators",
    description: "Glass elevators that combine functionality with architectural aesthetics, commonly used in hotels, malls, and luxury developments.",
    icon: "Eye"
  },
  {
    title: "Hospital Elevators",
    description: "Specialized elevators designed to accommodate stretchers and medical equipment while ensuring smooth, stable transportation.",
    icon: "Heart"
  },
  {
    title: "Villa Elevators",
    description: "Compact elevator systems designed specifically for private residences, offering convenience, accessibility, and modern design.",
    icon: "Home"
  }
];

const ElevatorTypes = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8">Types of Elevators We Provide</h2>
            <h3 className="text-4xl md:text-5xl font-bold text-[#4D4C4A] leading-tight mb-8 italic tracking-tighter">
              Versatile Lifting <br />
              <span className="text-[#91756A]">Solutions</span> for Every Need.
            </h3>
            <p className="text-slate-500 text-lg leading-relaxed mb-12 max-w-xl">
              From high-traffic commercial buildings to private luxury residences, our range of elevators is engineered 
              to meet the unique demands of any architectural project.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <div className="px-6 py-4 bg-slate-50 border border-slate-100 italic">
                <span className="text-[#4D4C4A] font-bold">Safe • Smooth • Reliable</span>
              </div>
            </div>
          </motion.div>

          <div className="grid gap-6">
            {types.map((type, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.6 }}
                className="group flex items-center gap-6 p-6 bg-slate-50 border-l-2 border-transparent hover:border-[#91756A] hover:bg-white hover:shadow-xl transition-all duration-300"
              >
                <div className="w-12 h-12 bg-[#4D4C4A] flex items-center justify-center shrink-0 group-hover:bg-[#91756A] transition-colors duration-300">
                  <Icon name={type.icon} size={20} className="text-white" />
                </div>
                <div>
                  <h4 className="text-lg font-bold text-[#4D4C4A] italic uppercase tracking-tight mb-1">{type.title}</h4>
                  <p className="text-slate-500 text-sm leading-relaxed max-w-md">
                    {type.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ElevatorTypes;